module.exports = __webpack_public_path__ + "media/img/payment-methods/jcb-81c3670b68f50dbf140eed37e3703b0d.svg";